<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" auto-complete="on" label-position="left">
      <el-form-item prop="account">
        <el-input v-model="form.account" placeholder="手机号码" type="text" prefix-icon="el-icon-mobile-phone"></el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          type="password"
          placeholder="登录密码"
          name="password"
          tabindex="3"
          @keyup.enter.native="handleLogin"
          prefix-icon="el-icon-unlock"
          :show-password="true"
        ></el-input>
      </el-form-item>
      <div class="my-flex my-row-right my-p-b-10" style="margin-top: -10px;">
        <div class="my-flex-1">
          <el-link type="primary" :underline="false" @click="handleReset">忘记密码</el-link>
        </div>
        <span style="color:#C3C3C3">没有账号？</span>
        <el-link type="primary" :underline="false" @click="$emit('change')">去注册</el-link>
      </div>
    </el-form>

    <el-button :loading="loading" type="primary" style="width:100%;" @click="handleLogin" size="default">登录</el-button>

    <book-dialog ref="bookDialog" :list="bookList" :bookId="bookId" @confirm="confirmBook" />
  </div>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import API_User from '@/api/user'
import API_tenant from '@/api/tenant'
import API_book from '@/api/book'
import { setToken } from '@/utils/auth'
import bookDialog from './bookDialog'
export default {
  name: '',
  components: {
    bookDialog
  },
  props: {},
  data() {
    return {
      form: {
        account: '',
        password: ''
      },
      rules: {
        account: [{ required: true, message: '请输入手机号', trigger: 'change' }]
      },
      loading: false,
      bookId: '',
      bookList: []
    }
  },

  computed: {
    ...mapGetters(['softPrice'])
  },
  created() {},
  methods: {
    handleReset() {
      let url = this.softPrice.softWebUrl + '/login/resetPassword'
      window.open(url)
    },
    handleLogin() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.account.toLowerCase() == 'demo') {
            this.$Message({
              showClose: true,
              message: '请登录您自己的账号',
              type: 'error'
            })
            return false
          }
          this.loading = true
          let obj = JSON.parse(JSON.stringify(this.form))
          obj.platform = 'web'
          obj.product = this.utils.getProductCode()
          //账号登录
          API_tenant.login(obj)
            .then(res => {
              this.loading = false
              if (
                res.data.errorCode &&
                res.data.errorCode != 'BOOK_SELECT' &&
                res.data.errorCode != 'BOOK_EXPIRED' &&
                res.data.errorCode != 'PASSWORD_REQUIRED' &&
                res.data.errorCode != 'PASSWORD_ERROR'
              ) {
                //有错误代码（这里仅登录账号，不验证账本相关，所以忽略账本相关错误代码）
                this.$Message({
                  showClose: true,
                  message: res.data.errorMessage,
                  type: 'error'
                })
              } else {
                //无错误代码，登录成功
                this.$Message({
                  showClose: true,
                  message: '登录成功',
                  type: 'success'
                })
                //保存token
                setToken(res.data.auth)
                //获取userInfo
                API_User.getInfo({ refresh: true }).then(res => {
                  //保存账本信息
                  if (res.data.tenantAccount.toLowerCase() != 'demo') {
                    this.$store.dispatch('dataCache/setUserInfo', res.data)
                  }
                })
                //获取账本列表
                this.bookId = res.data.book.id

                API_book.getList({}).then(res => {
                  console.log('API_book res', res)
                  //多个账本 手动指定一个账本
                  if (res.data.length > 1) {
                    this.bookList = res.data
                    this.$refs.bookDialog.open()
                  } else {
                    //账本id回调
                    this.$emit('confirm', this.bookId)
                  }
                })
              }
            })
            .catch(err => {
              console.log('login err', err)
              this.loading = false
              this.$Message({
                showClose: true,
                message: err.data.message,
                type: 'error'
              })
            })
        }
      })
    },
    confirmBook(bookId) {
      console.log('confirmBook', bookId)
      //账本id回调
      this.$emit('confirm', bookId)
    }
  }
}
</script>
  <style lang="scss" scoped>
</style>
  